import ThemeContext from "components/app/Context";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Item from "components/features/MyPlans/item";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import NoPropertyPlansBanner from "../IndividualProperty/NoPropertyPlansBanner";
import TableHeader from "../MyPlans/TableHeader";

interface Prop {
  label?: string;
  fetchMore: () => void;
}

const PlansList = (props: Prop) => {
  const { label = "", fetchMore } = props;
  const { totalList, list: userplans } = useAppSelector((state) => state.individualUser.plans);
  const { isMobileScreen } = useContext(ThemeContext);
  const showIndividualUserLoader = useAppSelector((state) => state.individualUser.showIndividualUserLoader);
  return (
    <>
      {userplans?.length ? (
        <>
          {!isMobileScreen && <TableHeader />}
          <Scroller dataLength={userplans?.length} loadMore={fetchMore} totalList={totalList} label={label}>
            {userplans?.map((plan: any) => {
              return <Item key={plan.id} plan={plan} />;
            })}
          </Scroller>
        </>
      ) : (
        !showIndividualUserLoader && <NoPropertyPlansBanner />
      )}
    </>
  );
};

export default PlansList;
